import {
    IPropertyPaneButtonProps
} from '@microsoft/sp-webpart-base';

export class ICustomButtonPane implements IPropertyPaneButtonProps {
    text: string;
    onClick: (value: any) => any;
}